var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHlaA130104(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "40 40 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #beda76;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.1,87.2l-12.8-12.8c-.7-.7-1.9-.7-2.7,0l-27.8,27.8-11.5-11.5c-7.3-7.3-7.3-19.1,0-26.4,3.5-3.5,8.2-5.5,13.2-5.5s9.7,1.9,13.2,5.5l6.9,6.9c.7.7,1.9.7,2.7,0,.7-.7.7-1.9,0-2.7l-6.9-6.9c-4.2-4.2-9.9-6.6-15.9-6.6-6,0-11.7,2.3-15.9,6.6-8.8,8.8-8.8,23,0,31.8l12.8,12.8c.4.4.8.6,1.3.6s1-.2,1.3-.6l27.8-27.8,11.5,11.5c3.5,3.5,5.5,8.2,5.5,13.2s-1.9,9.7-5.5,13.2c-7.3,7.3-19.1,7.3-26.4,0l-6.4-6.4c-.7-.7-1.9-.7-2.7,0-.7.7-.7,1.9,0,2.7l6.4,6.4c4.4,4.4,10.1,6.6,15.9,6.6s11.5-2.2,15.9-6.6,6.6-9.9,6.6-15.9-2.3-11.7-6.6-15.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71,68.4c-.7-.7-1.9-.7-2.7,0-2.5,2.5-3.9,5.9-3.9,9.5s1.4,7,3.9,9.5l4.7,4.7c.4.4.9.6,1.3.6s1-.2,1.3-.6c.7-.7.7-1.9,0-2.7l-4.7-4.7c-1.8-1.8-2.8-4.2-2.8-6.8s1-5,2.8-6.8c.7-.7.7-1.9,0-2.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.7,112.1c.4.4.9.6,1.3.6s1-.2,1.3-.6c5.2-5.2,5.2-13.8,0-19l-4.7-4.7c-.7-.7-1.9-.7-2.7,0-.7.7-.7,1.9,0,2.7l4.7,4.7c3.8,3.8,3.8,9.9,0,13.6s-.7,1.9,0,2.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlaA130104);
export default __webpack_public_path__ + "static/media/hla-a13-01-04.b4dd64b55f47166466bf2ee13682ea60.svg";
export { ForwardRef as ReactComponent };